<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {UIRectangle} from './rectangle';
    import ConfigInput from "../utils/ConfigTextInput.svelte";
    import {UIElement} from '../element';
    import {OriginCoords} from '../../types';
    import {isStringColorString} from "../../utils/helpers";

    export let uiElement: UIRectangle;
    export let origin: OriginCoords;

    let nameValue = uiElement.name;
    let xValue = uiElement.x.toString();
    let yValue = uiElement.y.toString();
    let widthValue = uiElement.width.toString();
    let heightValue = uiElement.height.toString();
    let colorValue = uiElement.color;
    let groupValue = uiElement.group;
    let zValue = uiElement.z;
    function onValueChange(attributeName: keyof UIRectangle | keyof UIElement, parseValueToInt = true) {
        return (value) => {
            uiElement[attributeName] = parseValueToInt ? parseInt(value.detail) : value.detail;
            guiCreatorDataStore.update(uiElement);
        }
    }


</script>

<div>

    <div class="flex flex-row bg-center pt-1">
        <p class="text-lg">Infos: Rectangle</p>
    </div>

    <ConfigInput value="{nameValue}" on:configValueChanged={onValueChange('name', false)} title="Name"></ConfigInput>
    <ConfigInput value="{groupValue || ''}" on:configValueChanged={onValueChange('group', false)}
                 title="Group"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Position</p>
    </div>
    <ConfigInput value="{xValue}" on:configValueChanged={onValueChange('x', true)}
                 title="X"></ConfigInput>
    <ConfigInput value="{yValue}" on:configValueChanged={onValueChange('y', true)}
                 title="Y"></ConfigInput>
    <ConfigInput value="{zValue}" on:configValueChanged={onValueChange('z', true)}
                 title="Z"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Measurements</p>
    </div>
    <ConfigInput value="{widthValue}" on:configValueChanged={onValueChange('width', true)} title="Width"></ConfigInput>
    <ConfigInput value="{heightValue}" on:configValueChanged={onValueChange('height', true)}
                 title="Height"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Look</p>
    </div>
    <ConfigInput value="{colorValue}" validator="{isStringColorString}"
                 on:configValueChanged={onValueChange('color', false)} title="Color"></ConfigInput>

</div>

<style>

    .text-input-combination {
        border-style: dashed;

        display: grid;
        grid-template-columns: 60px 80%;
    }
</style>
